import React from "react";
import { ObjectIcon } from "./ObjectIcon";
import { BoxIcon } from "lucide-react";
export interface HighlightField {
  label: string;
  value: React.ReactNode;
}
interface RecordHeaderProps {
  objectLabel: string;
  title: string;
  icon: BoxIcon;
  iconBg: string;
  titleAddon?: React.ReactNode;
  actions?: React.ReactNode;
  fields?: HighlightField[];
  toolbar?: React.ReactNode;
}
export function RecordHeader({
  objectLabel,
  title,
  icon,
  iconBg,
  titleAddon,
  actions,
  fields,
  toolbar
}: RecordHeaderProps) {
  return <section className="rounded border border-sf-border bg-white shadow-card" data-id="element-874" data-mp="iuchdugtankg">
      <div className="flex flex-wrap items-center justify-between gap-4 px-4 py-3" data-id="element-875" data-mp="wtkmf3znopwk">
        <div className="flex min-w-0 items-center gap-3" data-id="element-876" data-mp="rvaowmqgld7s">
          <ObjectIcon icon={icon} bg={iconBg} size="lg" data-id="element-877" data-mp="rtpvj0fvs0bi" />
          <div className="min-w-0" data-id="element-878" data-mp="2ymrym4jz2re8">
            <p className="text-xs text-sf-weak" data-id="element-879" data-mp="2yntnpcxtpeey">{objectLabel}</p>
            <div className="flex flex-wrap items-center gap-2" data-id="element-880" data-mp="2to784wuivm2z">
              <h1 className="text-lg font-bold leading-6 text-sf-text" data-id="element-881" data-mp="326pzlukeneqc">{title}</h1>
              {titleAddon}
            </div>
          </div>
        </div>
        {actions && <div className="flex shrink-0 items-center gap-2" data-id="element-882" data-mp="372ya2unnqjr6">{actions}</div>}
      </div>
      {toolbar && <div className="border-t border-sf-border px-4 py-2.5" data-id="element-883" data-mp="3c2ayvky3a0we">{toolbar}</div>}
      {fields && <dl className="flex flex-wrap gap-x-10 gap-y-2 border-t border-sf-border px-4 py-2.5" data-id="element-884" data-mp="3gwf521zj64wf">
          {fields.map(field => <div key={field.label} className="min-w-0" data-id="element-885" data-mp="3kz1yg7bunxvq">
              <dt className="text-xs text-sf-weak" data-id="element-886" data-mp="3puhbix219pr3">{field.label}</dt>
              <dd className="mt-0.5 text-[13px] text-sf-text" data-id="element-887" data-mp="3uuc3z51gine9">{field.value}</dd>
            </div>)}
        </dl>}
    </section>;
}